import bootstrap from 'bootstrap';
import slick from 'slick-carousel';
import Cookies from 'js-cookie';
import counterUp from 'counterup2';
// import Readmore from 'readmore-js';
import matchHeight from 'jquery-match-height';
import AOS from 'aos';


import './sass/main.scss';

// const memberContent = document.querySelectorAll('.member-content p');

// new Readmore('.member__read-more', {
//   collapsedHeight: 170,
//   speed: 200,
//   lessLink: '<a href="#">Read less</a>'
// });



$(document).ready(function() {



	  $('.member__name').matchHeight();
    $('.member__designation').matchHeight();
    // $('.member__grid').matchHeight();


    // $(".archive-filter input").on("change", function() {
    //   console.log('checnag');
    //     $(".archive-filter .btn").trigger('click');
    // });

    $(".archive-filter input[type='radio']").on("change", function() {
      $(this).closest('form').submit();
    });
  

    $('.hero-slider .slider').slick({
        arrows: false,
        dots: true
    });

    $('.hero-slider .slider').on('afterChange', function() {

        $('.hero-slider__video video').each(function() {
          $(this).get(0).pause();
      });
     
        var video = $(this).find('.slick-current').find('video')[0];

        if (video != null) {
            video.play();
        } 
    }); 

    for( let i = 1; i <= 9; i++) {
      $('.gallery-columns-' + i).slick({
        slidesToShow: i,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      });
    }
    
   

    $('.acf-banner-slider .slider').slick({
        arrows: false,
        dots: true
    });

    $('.acf-banner-tiles .slider').slick({
      arrows: false,
      dots: true,
      speed: 500,
      fade: true,
      autoplay: true,
      autoplaySpeed: 10000,
      cssEase: 'linear',
      adaptiveHeight : true
  });


    $('.acf-carousel__slick').each(function() {

        $(this).slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            mobileFirst: true,
            responsive: [
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 4
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 5
                  }
                }
              ]
        });
    });

    $('.filter-item a').click(function(e) {
	     window.location.replace($(this).attr('href'));
    });

    
    $('.clubs__terms a').click(function(e) {
      e.preventDefault();
      
      let club_id = $(this).data('id');

      $(this).toggleClass('check');
      $('#checkbox-' + club_id).find('input').trigger('click');

      // if($(this).hasClass('check')) {
        $('.clubs__form .btn').trigger('click');
      // }

    });

    $('.clubs__collapse input').click(function(e) {
      let check_id = $(this).closest('.form-check').data('id');
      let club = $('.clubs__terms a[data-id="' + check_id + '"]');

      if( $(this).is(':checked') ) {
        club.addClass('check');
      } else {
        club.removeClass('check');
      }

    });

    $('.state--url').click(function() {
      window.location.href = $(this).data('href');
    });

    $('#mac_sports_type input:checkbox:checked').each(function(e) {
      let check_id = $(this).val();
      $('.clubs__terms a[data-id="' + check_id + '"]').addClass('check');
    })

    $('.member__read-more').click(function(){
      $(this).siblings('div').toggle();
      $(this).text(function(i, text){
        return text === "Read More" ? "Read Less" : "Read more";
    })
 });


});



let lastScrollTop; 
let navbar = document.querySelector('.site-header'); 

window.addEventListener('scroll',function(){
  
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  if(scrollTop > lastScrollTop && scrollTop > 500){ 
    navbar.classList.add('hide');
  }
  
  else{
    navbar.classList.remove('hide');

  }
  
  lastScrollTop = scrollTop; 
});

AOS.init({
  easing: 'linear',
  offset: 50
});

const callback = entries => {
	entries.forEach( entry => {
		const el = entry.target
		if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
			counterUp( el, {
				duration: 1000,
				delay: 16,
			} )
			el.classList.add( 'is-visible' )
		}
	} )
}

const IO = new IntersectionObserver( callback, { threshold: 1 } )

const counter = document.querySelectorAll( '.counter' );

counter.forEach((el) => {
  IO.observe(el);
})


// const counter = document.querySelectorAll( '.counter' );

// document.addEventListener('aos:in', ({ detail }) => {
//     console.log(detail)

//   counter.forEach( el => {
//     counterUp( el, {
//       duration: 1000,
//       delay: 16,
//     })
//   })

// });


//if(counter) {

  // counter.forEach( el => {
  //   counterUp( el, {
  //     duration: 1000,
  //     delay: 16,
  //   })
  // })
  
//}

// const states = document.querySelectorAll('.state-nav__menu .dropdown-item');

// if( states ) {

//   states.forEach( state => {
//     state.addEventListener('click', event => {
//         event.preventDefault();

//         const state_url = event.target.getAttribute('href');
//         const state_id = event.target.dataset.id;
//         const state_club_term = event.target.dataset.term;
//         const state_name = event.target.text;
//         // const state_url = e.target.value;
//         // // const state_name = state.options[state.selectedIndex].text;
//         // // const state_id = state.options[state.selectedIndex].dataset.id;
//         // Cookies.set('current_state_name', state_name);
//         // Cookies.set('current_state_id', state_id);
//         // Cookies.set('current_state_club_term', state_club_term );
//         window.location.href = state_url;

//     })
//   })

// }



